import { pageViewsCountAtom } from "@/state/feedbackNudge.state";
import { useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function PageViewTracker() {
  const location = useLocation();
  const setCount = useSetAtom(pageViewsCountAtom);

  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    // Avoid double-counting the same path
    if (lastPathRef.current === location.pathname) return;
    lastPathRef.current = location.pathname;
    setCount((c) => c + 1);
  }, [location.pathname, setCount]);

  return null;
}
